<template>
  <div>
    <v-dialog v-model="billingSelectDialog" max-width="500">
      <v-card>
        <v-card-title class="justify-center">{{ $t('bill.select_bill_type') }}</v-card-title>
        <v-card-text class="py-5">
          <!-- Content Space -->
          <div class="py-2">
            <v-btn color="primary" elevation="0" large block @click="InvoiceDialog(true, 3)">{{ $t('bill.checkin_bill') }}</v-btn>
          </div>
          <div class="py-2">
            <v-btn color="primary" elevation="0" large block @click="InvoiceDialog(true, 2)">{{ $t('bill.deposit_bill') }}</v-btn>
          </div>
          <div class="py-2">
            <v-btn color="primary" elevation="0" large block @click="InvoiceDialog(true, 5)">{{ $t('bill.other_bill') }}</v-btn>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center mx-2">
          <v-btn color="error" elevation="0" @click="onCancel">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <invoice-dialog-component v-if="getProjectId" :projectId="getProjectId" :documentType="isInvoiceDialogDocumentType"
      :contractData="contract || getContract" v-model="isInvoiceDialog" @onSaveSuccess="onSaveSuccess"
      @onRemoveSuccess="onRemoveInvoiceSuccess"></invoice-dialog-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InvoiceDialogComponent from "./InvoiceDialog.component.vue";
export default {
  components: { InvoiceDialogComponent },
  name: "BillingSelect",
  computed: {
    ...mapGetters({
      getProjectId: "markets/getProjectId",
      getContract: "contract/getContract",
    }),
    billingSelectDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(data) {
      if (data) {
        this.initData();
      }
    },
  },
  created() { },
  data() {
    return {
      form: {},
      isInvoiceDialog: false,
      isInvoiceDialogDocumentType: 2,
    };
  },
  props: {
    value: Boolean,
    objectId: String,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean,
    contract: Object
  },
  methods: {
    async initData() { },
    async saveData() { },
    onSaveSuccess() {
      this.billingSelectDialog = false;
      this.$emit("onSaveSuccess");
    },
    onRemoveInvoiceSuccess() {
      this.billingSelectDialog = false;
      this.$emit("onRemoveSuccess");
    },
    InvoiceDialog(status = true, type = 2) {
      this.isInvoiceDialog = status;
      this.isInvoiceDialogDocumentType = type;
    },
    onSave() {
      this.billingSelectDialog = false;
    },
    onCancel() {
      this.$emit("onCancel");
      this.billingSelectDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
